import React, { Component } from 'react'

// CSS
import './Navigation.css'

class Navigation extends Component {

  render() {
    return (
      <nav className="navigation">
        <ul>
          {this.props.children}
        </ul>
      </nav>
    )
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/header/navigation/Navigation.js